import React from 'react'
import NON_IDEAL_STATE_SVG from './non-ideal-state.svg'
import { Block } from '../block/block'

export const NonIdealState = ({ children, height = 'calc(100vh - 568px)' }) => {
  return (
    <Block
      align='center'
      justify='center'
      style={{ height }}
      maxWidth={540}
      gap={40}
      margin='0 auto 40px auto'
    >
      <img src={NON_IDEAL_STATE_SVG} />
      {children}
    </Block>
  )
}
